import React from 'react';

interface HeroTitleProps {
  title: string;
  highlightPhrase?: string;
}

export const HeroTitle: React.FC<HeroTitleProps> = ({ title, highlightPhrase }) => {
  const renderTitle = () => {
    if (!highlightPhrase || !title.includes(highlightPhrase)) {
      return title;
    }

    const parts = title.split(highlightPhrase);

    return (
      <>
        {parts[0]}
        <span className="font-bold text-[#8BC34A]">
          <br />
          {highlightPhrase}
          <br />
        </span>
        {parts[1]}
      </>
    );
  };

  return (
    <h1 
      className="text-[#2C2C2C] font-normal text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight max-w-full lg:max-w-[700px]"
      suppressHydrationWarning
    >
      {renderTitle()}
    </h1>
  );
};
